import { onPageLoad } from '../modules/page_lifecycle.js';
import { fetchWithCsrf } from '../modules/csrf.js';
import { qs } from '../modules/dom.js';
import { bootstrapModal, showModal, hideModal } from '../modules/bootstrap_ui.js';

function bindCompaniesWindow() {
  const container = qs('#companySelector');
  const searchForm = qs('#companySelectorForm');
  const companyNameInput = qs('#company_selector_name');
  const resultsContainer = qs('#companySelectorListing');
  const opener = qs('#companySelectLink');
  const clearer = qs('#companyClear');
  const companyNameDisplay = qs('#companyNameDisplay');
  const companyValue = qs('#company_name');
  const companyId = qs('#company_id');

  if (!container || !searchForm || !resultsContainer || !opener) return;

  bootstrapModal('companySelector');

  opener?.addEventListener('click', (event) => {
    event.preventDefault();
    showModal('companySelector');
    companyNameInput?.focus();
  });

  container.addEventListener('shown.bs.modal', () => {
    companyNameInput?.focus();
  });

  clearer?.addEventListener('click', (event) => {
    event.preventDefault();
    if (companyNameDisplay) {
      companyNameDisplay.style.opacity = '0';
      companyNameDisplay.textContent = '';
      requestAnimationFrame(() => {
        companyNameDisplay.style.opacity = '1';
      });
    }
    if (companyValue) companyValue.value = '';
    if (companyId) companyId.value = '';
  });

  searchForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    const params = new URLSearchParams({
      page: '1',
      limit: '30',
      roles: 'all',
      profiled: 'no',
      name: companyNameInput?.value || ''
    });

    const response = await fetchWithCsrf(`/companies/selector/list?${params.toString()}`, {
      headers: { Accept: 'text/html' }
    });
    if (!response.ok) return;

    resultsContainer.innerHTML = await response.text();
  });

  resultsContainer.addEventListener('click', (event) => {
    const link = event.target.closest('a');
    if (!link) return;

    event.preventDefault();
    if (companyNameDisplay) {
      companyNameDisplay.hidden = true;
      companyNameDisplay.innerHTML = link.innerHTML;
      companyNameDisplay.hidden = false;
    }
    if (companyValue) companyValue.value = link.innerHTML.trim();
    if (companyId) companyId.value = link.id.split('_')[1] || '';
    hideModal('companySelector');
  });
}

onPageLoad(bindCompaniesWindow);
